//Note: do not check in over this. When we run locally, we will be able to identify local testing using this.
export const buildInfo = {
  name: 'com.cts.ParaScope',
  ionicAppId: '6b9ec9dc',
  ionicAppChannel: 'configurable',
  publicVersion: '9.0.0',
  baselineBuildId: 8610226,
  date: '2026-11-03 13:24:33.902Z',
  internalVersion: '26.307.804',
};
